
import {
    transition,
    trigger,
    query,
    style,
    animate,
    group,
    animation
} from '@angular/animations';

export const ANIMATION_FADE_IN_OUT = animation([
  style({ opacity: '{{ start }}'}),
  animate('{{ time }}', style({ opacity: '{{ end }}' }))
]);


export const easyInTransition = trigger('routeAnimations', [
    transition('Access => *', [
        query(':enter, :leave', style({ position: 'fixed', width: '100%' }), {
            optional: true
        }),
        group([
            query(
                ':enter',
                [
                    style({ opacity: '0.3'}),
                    animate('1s',
                    style({ opacity: '1' }))
                ],
                { optional: true }
            ),
            query(
                ':leave',
                [
                    style({ opacity: '1'}),
                    animate('1s',
                    style({ opacity: '0.3' }))
                ],
                { optional: true }
            )
        ])
    ]),
    transition('Login => *', [
        // query(':enter, :leave', style({ position: 'fixed', width: '100%' }), {
        //     optional: true
        // }),
        group([
            query(
                ':enter',
                [
                    style({ opacity: '0.3'}),
                    animate('1s',
                    style({ opacity: '1' }))
                ],
                { optional: true }
            ),
            query(
                ':leave',
                [
                    style({ transform: 'translateX(0%)' }),
                    animate('0.5s ease-in-out', style({ transform: 'translateX(-100%)' }))
                ],
                { optional: true }
            )
        ])
    ]),
    transition('Option => *', [
        // query(':enter, :leave', style({ position: 'fixed', width: '100%' }), {
        //     optional: true
        // }),
        group([
            query(
                ':enter',
                [
                    style({ opacity: '0.3'}),
                    animate('1s',
                    style({ opacity: '1' }))
                ],
                { optional: true }
            ),
            query(
                ':leave',
                [
                    style({ opacity: '1'}),
                    animate('1s',
                    style({ opacity: '0.3' }))
                ],
                { optional: true }
            )
        ])
    ]),
    transition('Option => Login', [
        query(':enter, :leave', style({ position: 'fixed', width: '100%' }), {
            optional: true
        }),
        group([
            query(
                ':enter',
                [
                    style({ transform: 'translateX(-100%)' }),
                    animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' }))
                ],
                { optional: true }
            ),
            query(
                ':leave',
                [
                    style({ transform: 'translateX(0%)' }),
                    animate('0.5s ease-in-out', style({ transform: 'translateX(100%)' }))
                ],
                { optional: true }
            )
        ])
    ])
]);
